// Hetken palvelut. Järjestys = järjestys /palvelut-sivulla ja
// lomakkeen valinnoissa. Nimi ja kuvaus ovat translations.js:ssä
// t.services[id]. Uusi palvelu: lisää id tähän ja tekstit sinne.

export const services = [
  { id: "yhteiskunnallinen-viestinta" },
  { id: "kampanjat" },
  { id: "brandifilmi" },
  { id: "somesisallot" },
  { id: "tapahtumat" },
];
